export function priceFormatter(value: number, min?: number, max?: number) {
  return value.toLocaleString("en", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: min ?? 0,
    maximumFractionDigits: max ?? 0,
  });
}
